// extracted by mini-css-extract-plugin
module.exports = {"RelatedList":"RelatedList_RelatedList__57pwt","RelatedList_heading":"RelatedList_RelatedList_heading__HGJjX"};